export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const COVER_ART = "/mag/real/1.jpg";
export const PAPER_TEXTURE =
  "https://images.unsplash.com/photo-1719563015025-83946fb49e49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxjcmVhbSUyMHBhcGVyJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODgxOTUyMjN8MA&ixlib=rb-4.1.0&q=85";
